import { useNavigate } from 'react-router-dom'
import TopicIdeasMain from './topicideas/TopicIdeasMain'

const DashboardTopicIdeasRoute = () => {
  const navigate = useNavigate()

  const handleGenerateDocFromTopic = (topicId, topic) => {
    navigate(`/dashboard/project?topicId=${encodeURIComponent(String(topicId || ''))}&autoGenerate=1`, {
      state: { topic: topic || null, autoGenerate: true }
    })
  }

  return (
    <TopicIdeasMain
      onGenerateDocFromTopic={handleGenerateDocFromTopic}
    />
  )
}

export default DashboardTopicIdeasRoute

